import { gridSelector } from '@crm-framework/grid';

import { IStoreWithNotifications, INotificationsState } from './types';
import { NOTIFICATIONS_GRID_NAME } from './consts';

export const getNotificationData = (
  state: IStoreWithNotifications
): INotificationsState => state.notifications;

export const getUnreadMessages = (state: IStoreWithNotifications): number =>
  state.notifications.unreadMessages;

export const getNotMarkedAsReadSelectedIds = (
  state: IStoreWithNotifications
): number[] => {
  const { selectedIds } = state.notifications;
  const { items } = gridSelector(state, NOTIFICATIONS_GRID_NAME);

  return selectedIds.filter((selectedId) => {
    const notificationItem = items.find(
      (item) => item.notificationDetails.id === selectedId
    );

    return !notificationItem?.notificationDetails.isRead;
  });
};

export const getBUSelectOptions = (state: IStoreWithNotifications) =>
  state.notifications.userBusinessUnits;

export const getBUFilterValue = (state: IStoreWithNotifications) =>
  state.notifications.buFilterValue;

export const getIsBUFilterDisabled = (state: IStoreWithNotifications) =>
  state.notifications.isBUFilterDisabled;
